<template>
    <el-dialog :visible.sync="visible" title="保证金详情" width="1200px" top="5vh" :close-on-click-modal="false" :before-close="handleClose" custom-class="radius-dialog">
        <div v-loading="loadAll">
            <div class="filters-container">
                <div class="filter-line">
                    <div class="title-name">学校名称：</div>
                    <div class="filter-ipt">
                        <el-input prefix-icon="el-icon-search" v-model="filters.schoolName" placeholder="搜索学校名称" class="no-border" @change="fetchData" clearable />
                    </div>
                </div>
                <CheckedSelect v-model="filters.saleUserId" :options="mySaleUserOptions" label="销售人员" @change="fetchData" />
                <CheckedSelect v-model="filters.year" :options="yearOptions" label="年份选择" @change="fetchData" />
                <CheckedSelect v-model="filters.invoiceState" :options="[{id:'',name:'全部'},{id:1,name:'已开票'},{id:0,name:'未开票'}]" label="是否开票" @change="fetchData" />
                <CheckedSelect v-model="filters.refundState" :options="[{id:'',name:'全部'},{id:1,name:'已退回'},{id:0,name:'未退回'}]" label="是否退回" @change="fetchData" />
                <div class="red-text" v-if="totalCount">
                    <i class="el-icon-warning-outline"></i>
                    <span class="text" v-html="total_describe"></span>
                </div>
                <div class="export-box">
                    <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button>
                </div>
            </div>
            <el-table :data="tableData.slice((pageNum - 1) * pageSize, pageNum * pageSize)" row-key="contractId"
                :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }">
                <el-table-column label="序号" width="60" align="center">
                    <template slot-scope="{$index}">{{ $index + 1 + (pageNum - 1) * pageSize }}</template>
                </el-table-column>
                <el-table-column prop="schoolName" label="学校" min-width="150" align="left"></el-table-column>
                <el-table-column prop="saleUserName" label="销售" min-width="100" align="left"></el-table-column>
                <el-table-column prop="payDate" label="付款日期" min-width="120" align="left"></el-table-column>
                <el-table-column prop="payPrice" label="付款金额(元)" width="120" align="left">
                    <template slot-scope="{row}">￥{{ row.payPrice }}</template>
                </el-table-column>
                <el-table-column prop="invoiceState" label="是否开票" min-width="100" align="left">
                    <template slot-scope="{row}">
                        <i :class="[row.invoiceState == 1 ? 'el-icon-success' : 'el-icon-error', row.invoiceState == 1 ? 'green' : 'red']"
                            style="margin-right: 4px; font-size: 18px; vertical-align: text-bottom;"></i>
                        <span>{{ row.invoiceState === 1 ? '已开票' : '未开票'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refundState" label="是否退回" min-width="100" align="left">
                    <template slot-scope="{row}">
                        <i :class="[row.refundState == 1 ? 'el-icon-success' : 'el-icon-error', row.refundState == 1 ? 'green' : 'red']"
                            style="margin-right: 4px; font-size: 18px; vertical-align: text-bottom;"></i>
                        <span>{{ row.refundState === 1 ? '已退回' : '未退回'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refundDate" label="退回日期" min-width="120" align="left"></el-table-column>
                <el-table-column prop="refundPrice" label="退回金额(元)" width="120" align="left">
                    <template slot-scope="{row}" v-if="row.refundPrice">￥{{ row.refundPrice }}</template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="250" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination v-show="totalCount" :total="totalCount" :page.sync="pageNum" :limit.sync="pageSize" :pageSizes="[10, 20, 40, 50]" style="margin-top: 20px;" />
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { findDepositStatistics, downloadDepositList } from '@/api/statistics/index.js';

export default {
    name: 'depositDetail',
    props: {
        visible: Boolean, // 弹窗显示/隐藏
        params: Object, // 总览统计的参数
    },
    watch: {
        visible(val) {
            if (val) {
                this.pageNum = 1;
                this.pageSize = 10;
                this.filters.schoolName = ''
                this.filters.saleUserId = this.params.saleUserId;
                this.filters.year = this.params.year || '';
                this.filters.invoiceState = ''
                this.filters.refundState = 0
                this.fetchData();
            }
        }
    },
    data() {
        return {
            loadAll: true,
            filters: {
                schoolName: '',
                saleUserId: '',
                year: '',
                invoiceState: '',
                refundState: 0
            },
            // 分页
            pageNum: 1,
            pageSize: 10,
            // 表格数据
            tableData: [],
            totalCount: 0, // 合同总数量
            // 文字说明
            total_describe: '',
            // 导出
            loadExport: false,
        }
    },
    computed: {
        ...mapState(["productList", "mySaleUserOptions", "yearOptions", "monthOptions"]),
    },
    methods: {
        // 获取数据
        fetchData() {
            this.loadAll = true;
            findDepositStatistics({ ...this.filters, currentPage: this.pageNum, limit: this.pageSize }).then(res => {
                let { year, totalCount, payPriceTotal, refundPriceTotal, needRefundPriceTotal } = res.data;
                this.totalCount = totalCount;
                this.tableData = res.data.depositList || [];
                this.total_describe = `根据筛选条件，${year ? `<b>${year}</b>年` : ''}共支付保证金<b>${totalCount}</b>次，总金额<b>${payPriceTotal}</b>万元，已退回金额<b>${refundPriceTotal}</b>万元，未退回金额<b>${needRefundPriceTotal}</b>万元。`
                this.loadAll = false;
            }).catch(err => {
                if (err.status === 888) return;
                this.totalCount = 0;
                this.tableData = [];
                this.total_describe = '';
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 统计方式 选中“按到账日期统计”时，不显示是否到账，清空选项
        statisticsTypeChange() {
            if (this.filters.statisticsType === 1) {
                this.filters.receiveFlag = '';
            }
            this.fetchData()
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("update:visible", false);
        },
        // 点击导出
        exportData() {
            this.loadExport = true;
            downloadDepositList(this.filters).then(res => {
                // 处理blob
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                        this.loadExport = false;
                    });
                } else {
                    // 成功，预览/下载报告
                    this.$utils.download(res);
                    this.loadExport = false;
                }
            }).catch(() => {
                this.loadExport = false;
            })
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .radius-dialog {
    background-image: url("~@/assets/image/statistics/dialog-bg.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    .el-dialog__body {
        padding: 15px 30px 30px 30px;
    }
    .el-dialog__header {
        padding-left: 30px;
        padding-right: 30px;
        .el-dialog__title {
            font-weight: 600;
        }
    }
    .dialog-title {
        h3 {
            display: inline-block;
            margin-right: 12px;
        }
        span {
            color: #7c7c7c;
            font-size: 14px;
        }
    }
}
.filters-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-bottom: 20px;
    border-radius: 10px;
    /deep/ .filter-line {
        display: flex;
        &:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .title {
            min-width: 5rem;
            padding-top: 7px;
            color: $primary-font-color;
        }
        .title-name {
            min-width: 5rem;
            padding-top: 7px;
            color: $primary-font-color;
            white-space: nowrap;
        }
        .filter-ipt {
            width: 40%;
            border-radius: 1.6rem;
            box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
            overflow: hidden;
            padding: 0 0.6rem;
            > .el-input {
                .el-input__inner {
                    height: 2.2rem;
                    line-height: 2.2rem;
                }
                .el-input__icon {
                    line-height: 2.2rem;
                }
            }
        }
    }
    .export-box {
        position: absolute;
        bottom: 0;
        right: 20px;
        > .el-button {
            border-radius: 0.8rem;
        }
    }
}
.red-text {
    max-width: calc(100% - 160px);
    color: #f53f3f;
    i {
        margin-right: 2px;
        font-size: 18px;
        font-weight: 600;
        vertical-align: -1px;
    }
    /deep/ .text b {
        margin: 0 2px;
    }
}
.green {
    color: #56b562;
}
.red {
    color: #f56c6c;
}
</style>